// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ExclamationMarkOutlineComponent} from './ExclamationMarkOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconExclamationMarkOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ExclamationMarkOutlineComponent/>
  </Icon>
));
